import { render } from "./TextDivider.vue?vue&type=template&id=1358b4c6&scoped=true"
import script from "./TextDivider.vue?vue&type=script&lang=js"
export * from "./TextDivider.vue?vue&type=script&lang=js"

import "./TextDivider.vue?vue&type=style&index=0&id=1358b4c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1358b4c6"]])

export default __exports__